<script>
export default {
  name: 'cart-btn',
  /**
   * 按钮状态
   *  0 常规状态，加入购物车
   *  1 区域经销,议价商品
   *  2 缺货
   *  3 已抢光
   */
  props: {
    btnType: {
      type: Number,
      default: 0
    }
  },
  methods: {
    openCart () {
      this.$emit('openCart')
    },
    fn () {
      return false
    }
  },
  render () {
    const { btnType, $style } = this
    switch (btnType) {
      case 0:
        return <cc-svg-icon
          size="24px"
          icon-class="shop-cart"
          vOn:click_stop={this.openCart}
          class={`${$style['shopCartIcon']}`}
        ></cc-svg-icon>
      case 1:
        return <span class={`${$style['region-btn']}`} vOn:click_stop={this.openCart}>申</span>
      case 2:
        return <span class={`${$style['region-btn']}`} vOn:click_stop={this.openCart}>订</span>
      case 3:
        return <cc-svg-icon
          size="24px"
          icon-class="shop-cart"
          vOn:click_stop={this.fn}
          class={`${$style['nogoodscart']}`}
        ></cc-svg-icon>
      default:
        return <cc-svg-icon
          size="24px"
          icon-class="shop-cart"
          class={`${$style['shopCartIcon']}`}
          vOn:click_stop={this.openCart}
        ></cc-svg-icon>
    }
  }
}
</script>
<style module lang="scss">
.shopCartIcon{
  color: var(--APP_theme_color);
}
.nogoodscart{
  color: #b1b1b1;
}
.region-btn{
  display: flex;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  @include center();
  box-sizing: border-box;
  border:1px solid var(--APP_theme_color);
  background:var(--APP_theme_color_colorOpacity1) ;
  color: var(--APP_theme_color);
  font-size: 12px;
}
</style>
